import Entity from './entity'
import PurchaseOrderMedia from './purchase-order-media'

export default class PurchaseOrderCheckIn extends Entity<number>{
    orderNo: number;
    code : string;
    numOfPacks : number;
    arrivedAt : Date;
    poId : number;
    note : string;
    containerNumber : string;
    driverName: string;
    driverPhone: string;
    creationTime : Date;

    poMedias: Array<PurchaseOrderMedia> = new Array<PurchaseOrderMedia>();
    poCode : string;
}